import React, { useState } from "react";
import cards from "../data/cards";
import { gsap, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
function Card(props) {
  gsap.registerPlugin(ScrollTrigger);

  const [modal, setModal] = useState(false);

  const [play, setPlay] = useState(1);

  function onHandle() {
    setPlay((_) => {
      return 0;
    });
  }

  function onLeave() {
    setPlay(() => {
      return 1;
    });
  }

  return (
    <div className="card">
      <a href={props.link} target="_blank">
        <div
          className="card__Img"
          onMouseOver={onHandle}
          onMouseLeave={onLeave}
        >
          <img className="card__Img--Item" src={props.img} alt="" />
          <h3 className="card__Img--Place">{props.place}</h3>
        </div>
      </a>
      <h4 className="card__Work">{props.work}</h4>
      <h3 className="card__Title">{props.title}</h3>
      <h4 className="card__Type">{props.type}</h4>
    </div>
  );
}

export default Card;
